// Juros do parcelamento "sem juros" que a FEO absorve na Eduzz (vendas únicas).
// Regra: taxa de 2,80% ao mês pela Tabela Price (juros compostos), calibrada pelas faturas reais da Eduzz (4x, 10x, 12x),
// com benefício de 20% de desconto na taxa concedido pela Eduzz (a FEO absorve só 80% dos juros).
export const TAXA_PARCELAMENTO_MES = 0.028;
export const DESCONTO_BENEFICIO_TAXA = 0.2;

export function parcelasDaVenda(raw: unknown): number {
  const n = Number((raw as { data?: { installments?: unknown } } | null)?.data?.installments ?? 1);
  return Number.isFinite(n) && n >= 1 ? Math.floor(n) : 1;
}

function jurosBrutoPrice(valorPago: number, n: number): number {
  if (n <= 1) return 0;
  const i = TAXA_PARCELAMENTO_MES;
  const vp = (valorPago / n) * ((1 - Math.pow(1 + i, -n)) / i);
  return valorPago - vp;
}

export function jurosParcelamento(valorPago: number, parcelas: number): number {
  const n = Math.max(1, Math.floor(parcelas));
  const efetivo = jurosBrutoPrice(valorPago, n) * (1 - DESCONTO_BENEFICIO_TAXA);
  return Math.round(efetivo * 100) / 100;
}

export function valorLiquidoUnica(valorPago: number, parcelas: number): number {
  return Math.round((valorPago - jurosParcelamento(valorPago, parcelas)) * 100) / 100;
}
